import { computeFingerprint } from "./fingerprint";
import { constants } from "./constants";




const getAdPushAccountId = (): string => {
  const elm = <HTMLScriptElement>document.getElementById(constants.ADPUSH)
  return elm?.dataset.accountid || "";
}

const getBaseUrl = (): string => {
  const elm = <HTMLScriptElement>document.getElementById(constants.ADPUSH)
  const url = new URL(elm?.src) 
  if (url.port && url.port != "80") {
    return url.protocol + "//" + url.hostname + ":" + url.port;
  }
  return url.protocol + "//" + url.hostname ;
}

const showSubsciptionFrame = (account: account) => {

  const prp = account.registration_page;
  const registrationPageUrl = account.registration_page_url + `?${constants.COOKIE_USER_ID}=${account.user.cookie_id}&${constants.COOKIE_USER_FP}=${account.user.fingerprint}`;
  const popup = window.open(registrationPageUrl, 'AdPushRegistrationPage', `left=${prp.position.left},top=${prp.position.top},height=${prp.position.height},width=${prp.position.width},popup=true`);

  if (popup) {
    popup.focus()
    return true;
  } else {
    console.log("popup blocked");
    // TODO: handle thise case. Maybe fall back to using the ush notification on the domain itself
    return false;
  }
}

const fetchAdPushConfig = async (baseUrl: string, accountId: string, user: user): Promise<account> => {
  const response = await fetch(`${baseUrl}/account/${accountId}/config?${constants.COOKIE_USER_ID}=${user.cookie_id}&${constants.COOKIE_USER_FP}=${user.fingerprint}`);
  if (!response.ok) {
    throw new Error("Failed to fetch account data");
  }
  return await response.json().then((data: account) => {
    data.use_top_banner = true;
    return data;
  });
}

const getAccountConfig = (user: user): Promise<account> => {
  const accountId = getAdPushAccountId();
  if (!accountId) {
    console.error("No account id found");
    return Promise.reject("No account id found");
  }

  return fetchAdPushConfig(getBaseUrl(), accountId, user);
}


const openRegistrationPage = (acc: account) => {
  return () => {
    startReceivingMessagesFromFrame();
    showSubsciptionFrame(acc);
  }
}

const showTopBanner = (acc: account) => {

  const bDiv = document.createElement("div");
  bDiv.id = constants.CSS_TOP_BANNER;
  bDiv.classList.add(constants.CSS_TOP_BANNER);
  bDiv.classList.add(constants.CSS_HIDDEN);

  addCloseButton(bDiv);


  setTimeout(() => {
    document.body.classList.add(constants.CSS_TOP_BANNER_TRANSITION_SLIDEDOWN);
  }, 3000);
  addVisibilityListener(document.body, bDiv);

  const cDiv = createTopBannerContent(acc);
  bDiv.appendChild(cDiv);
  document.body.append(bDiv);

  addStyle(acc);


  const buttons = document.getElementsByClassName(constants.CSS_TOP_BANNER_BUTTON);
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", openRegistrationPage(acc));
  }
}

const createTopBannerContent = (account: account) => {
  const cDiv = document.createElement("div");
  cDiv.id = constants.CSS_TOP_BANNER_CONTENT;
  cDiv.classList.add(constants.CSS_TOP_BANNER_CONTENT);

  let innerHTML = account.top_banner.raw_html || `
    <span class="adpush-top-banner-message">{{TEXT}}</span>
    <button class="adpush-top-banner-button" style="font-family: bold, sans-serif; font-weight: 600; font-size: clamp(12px, 18px, 2vw); line-height: 1; height: 36px; margin: 0px; padding: 5px 12px; outline: none; background: rgb(255, 255, 255); color: black; border: 1px solid rgb(0, 0, 0); cursor: pointer; display: flex; align-items: center;">{{BUTTON_TEXT}}</button>
`;

  innerHTML = innerHTML.replace(/\{\{TEXT\}\}/g, account.top_banner.text);
  innerHTML = innerHTML.replace(/\{\{BUTTON_TEXT\}\}/g, account.top_banner.button_text);
  cDiv.innerHTML = innerHTML;
  return cDiv;
}



const addCloseButton = (bDiv: HTMLDivElement) => {
  const bClose = document.createElement("span");
  bClose.textContent = "X";
  bClose.classList.add(constants.CSS_TOP_BANNER_CLOSE);
  bClose.onclick = closeTopBanner
  bDiv.appendChild(bClose);
}

const closeTopBanner = () => {
  document.body.classList.add(constants.CSS_TOP_BANNER_TRANSITION_SLIDEUP);
}

const addStyle = (account: account) => {
  const head = document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.textContent = `
    :root {
      --${constants.CSS_TOP_BANNER}-height: ${account.top_banner.height}px;
      --${constants.CSS_TOP_BANNER}-color: ${account.top_banner.background_color};
      --${constants.CSS_TOP_BANNER}-fontcolor: ${account.top_banner.font_color};
    }`;
  head.appendChild(style);

  const cssResource = document.createElement('link');
  cssResource.rel = "stylesheet";
  cssResource.href = getBaseUrl() +  "/ap/push.css";
  head.appendChild(cssResource);
}


const addVisibilityListener = (elem: HTMLElement, target: HTMLElement) => {
  elem.addEventListener("animationstart", () => {
    if (elem.classList.contains(constants.CSS_TOP_BANNER_TRANSITION_SLIDEDOWN)) {
      target.classList.remove(constants.CSS_HIDDEN);
    }
  }, false);
  elem.addEventListener("animationend", () => {
    if (elem.classList.contains(constants.CSS_TOP_BANNER_TRANSITION_SLIDEUP)) {
      target.classList.add(constants.CSS_HIDDEN);
    }
  }, false);
}


const startReceivingMessagesFromFrame = () => {
  window.addEventListener("message", (event) => {
    if (event.data?.type != constants.ADPUSH || !event.data?.data) {
      return
    }
    if (event.data.data.endpoint && event.data.data.endpoint.length > 0) {
      closeTopBanner();
    }
    localStorage.setItem(constants.LS_NOTIFICATION, JSON.stringify(event.data.data));
  });
}

const shouldOpenBanner = (): boolean => {
  const item = localStorage.getItem(constants.LS_NOTIFICATION);
  if (!item) {
    return true;
  }
  const data = (JSON.parse(item) as openerMessageData);

  // if nothing is set we ask for notification permission
  if (!data) {
    return true
  }

  // if the user has already made a decision we don't show the banner
  if (data.notificationState === "granted" || data.notificationState == "denied") {
    return false;
  }
  // if the user has not made a decision we ask for notification permission
  return true;
}

const selectFirstElement = (selector: trackingSelector[]): Element | null => {
  for (let i = 0; i < selector.length; i++) {
    const elem = selectElement(selector[i]);
    if (elem) {
      return elem;
    }
  }
  return null;
}

const selectFirstAttribute = (selector: trackingSelector[]): string | null => {
  for (let i = 0; i < selector.length; i++) {
    const attr = selectAttribute(selector[i]);
    if (attr) { 
      return attr;
    }
  }
  return null;
}

const selectElement = (selector: trackingSelector): Element | null => {
  return document.querySelector(selector.element);
}

const selectAttribute = (selector: trackingSelector): string | null => {
  const elem = selectElement(selector);
  if (!elem) {
    return null;
  }
  if (!selector.attribute) {
    return elem.textContent;
  }
  return elem.getAttribute(selector.attribute);
}

const setupDetailTracking = (account: account) => {
  if (!account.inactive.detail_name ) {
    return
  }

  const detailName = selectFirstAttribute(account.inactive.detail_name);
  const detailImageUrl = selectFirstAttribute(account.inactive.detail_img_url);
  const detailUrl = window.location.href;
  

  if (!detailName) {
    return
  }
  sendEvent({
    type: "DETAIL" as trackingEventType,
    accountId: account.id,
    user: account.user,
    name: detailName,
    imageUrl: detailImageUrl,
    url: detailUrl
  });  
}

const setupVisibilityListener = (account: account) => {
  document.addEventListener("visibilitychange", (event) => {

    const trackingEvent = {
      type: "UNSPECIFIED" as trackingEventType,
      accountId: account.id,
      user: account.user,
      url: window.location.href,
    }


    if (document.visibilityState === "hidden") {
      trackingEvent.type = "HIDDEN" as trackingEventType;
    } else {
      trackingEvent.type = "VISIBLE" as trackingEventType;
    }

    sendEvent(trackingEvent);
  });

}

const setCookie = (name: string, val: string | undefined) => {
  if (!val) {
    return
  }
  const date = new Date();
  const value = val;

  // Set it expire in 7 days
  date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));

  // Set it
  document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
}

const getCookie = (name: string): string => {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");

  if (parts.length == 2) {
    return parts.pop()?.split(";").shift() || "";
  }
  return "";
}


const sendEvent = (event: trackingEvent) => {
  const formData = new FormData();
  formData.append("type", event.type);
  formData.append("accountId", event.accountId);
  if (event.user && event.user.cookie_id) {
    formData.append("userId", event.user.cookie_id);
  }
  if (event.user && event.user.fingerprint) {
    formData.append("userFP", event.user.fingerprint);
  }
  if (event.type === "DETAIL" && event.name) {
    formData.append("detailName", event.name);
    if (event.imageUrl) {
      formData.append("detailImageUrl", event.imageUrl);
    }
  }

  if (event.url) {
    formData.append("url", event.url);
  }

  navigator.sendBeacon(getBaseUrl() + "/track", formData);
}


const getUser = async (): Promise<user> => {
  const ls = localStorage.getItem(constants.LS_USER);
  if (ls) {
    return JSON.parse(ls) as user;
  }
  const userId = getCookie(constants.COOKIE_USER_ID);
  let userFP = getCookie(constants.COOKIE_USER_FP);
  if (!userFP) {
    userFP = await computeFingerprint();
  }

  const user = {
    cookie_id: userId,
    fingerprint: userFP
  }
  return user
}

const storeUser = (user: user | undefined) => {
  if (!user) {
    return
  }
  localStorage.setItem(constants.LS_USER, JSON.stringify(user));
  setCookie(constants.COOKIE_USER_ID, user.cookie_id);
  setCookie(constants.COOKIE_USER_FP, user.fingerprint);
}

const setupClickListener = (account: account) => {
  if (!account.abandoned_cart.click_elements) {
    return
  }

  account.abandoned_cart.click_elements.forEach((selector) => {
    const elements = document.querySelectorAll(selector.element);
    elements.forEach((element) => {
      element.addEventListener("click", () => {
        const trackingEvent = {
          type: "CLICK" as trackingEventType,
          accountId: account.id,
          user: account.user
        }
        sendEvent(trackingEvent);
      });
    });
  });
}

const setupInactivityListener = (account: account) => {
  if (!account.tracking.inactivity_timeout || account.tracking.inactivity_timeout <= 0) {
    return
  }

  const tenSeconds = 10000;
  // wait at least 10 seconds
  const inactivity_timeout = account.tracking.inactivity_timeout < tenSeconds ? tenSeconds : account.tracking.inactivity_timeout;

  const sendInactivityEvent = () => {
    const trackingEvent = {
      type: "INACTIVE" as trackingEventType,
      accountId: account.id,
      user: account.user,
      timout: inactivity_timeout,
      url: window.location.href,
    } as trackingEvent
    sendEvent(trackingEvent);
  }
  let timerId = 0;
  const resetTimer = () => {
    if (timerId != 0) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(sendInactivityEvent, inactivity_timeout);
  }

  const eventNames = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
  eventNames.forEach((name) => {
    document.addEventListener(name, resetTimer, true);
  });
};

const setupTracking = (account: account) => {
  setupVisibilityListener(account);
  setupInactivityListener(account);

  if (account.abandoned_cart.enabled) {
    setupAbandonedCartTracking(account);
  }

  if (account.inactive.enabled) {
    setupInactivityTracking(account);
  }
}

const setupInactivityTracking = (account: account) => {
  setupDetailTracking(account);
  setupInactivityConversionTracking(account);
}

const setupAbandonedCartTracking = (account: account) => {
  setupClickListener(account);
  setupAbandonedCartConversionTracking(account);
}



const setupInactivityConversionTracking = (account: account) => {
  if (!account.inactive.conversion_elements) {
    return
  }

  const exists = selectFirstElement(account.inactive.conversion_elements) != null;
  if (!exists) {
    return
  }

  const trackingEvent = {
    type: "CONV_INACTIVE" as trackingEventType,
    accountId: account.id,
    user: account.user,
    url: window.location.href,
  }
  sendEvent(trackingEvent);
}


const setupAbandonedCartConversionTracking = (account: account) => {
  if (!account.abandoned_cart.conversion_elements) {
    return
  }

  const exists = selectFirstElement(account.abandoned_cart.conversion_elements) != null;
  if (!exists) {
    return
  }

  const trackingEvent = {
    type: "CONV_ABANDONED" as trackingEventType,
    accountId: account.id,
    user: account.user,
    url: window.location.href,
  }
  sendEvent(trackingEvent);
}


const main = async () => {

  const user = await getUser()
  const acc = await getAccountConfig(user);

  storeUser(acc.user);

  setupTracking(acc);

  if (acc.use_top_banner && shouldOpenBanner()) {
    showTopBanner(acc);
  }
  if (acc.use_registration_page) {
    const openRPButton = document.getElementById(constants.CSS_REGISTRATION_PAGE_ELEMENT);
    openRPButton?.addEventListener("click", openRegistrationPage(acc));
  }
}

main();
